import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemsSection } from './components/ProblemsSection';
import { FeaturesSection } from './components/FeaturesSection';
import { GamesShowcase } from './components/GamesShowcase';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-body text-gray-900 selection:bg-candy-pink selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemsSection data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <GamesShowcase data-id="element-6" />
        <PricingSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}